import React from 'react';
import PublicLayout, { LegalShell, PUBLIC_CONTACT_EMAIL } from '../../components/layout/PublicLayout';

const Privacy = () => (
  <PublicLayout title="Privacy Policy" description="VSKR Legal Privacy Policy — how we handle information across VSKR Legal and LIOS.">
    <LegalShell title="Privacy Policy" updated="December 2025">
      <p>This Privacy Policy explains how VSKR Legal ("we", "us") handles information in connection with the VSKR Legal website and our products, including LIOS. Please read it together with our Terms of Use.</p>

      <h2>1. Scope</h2>
      <p>This policy applies to information processed through our public website and our account-based services. Where a specific product has additional practices, those will be made available within that product.</p>

      <h2>2. Information you provide</h2>
      <ul>
        <li><strong>Account information</strong>: such as your name, email address, and details you choose to add to your profile.</li>
        <li><strong>Content you create or upload</strong>: documents and related material you add while using our services.</li>
        <li><strong>Communications</strong>: information you provide when you contact us for support.</li>
      </ul>

      <h2>3. Technical and usage information</h2>
      <p>To operate and secure our services, we process technical information such as IP address, device and browser information, and records of activity within the service (for example, pages visited and security events). We use this information for security, troubleshooting, and improving reliability.</p>

      <h2>4. Documents and user content</h2>
      <p>Documents and content you add remain associated with your account and are used to provide the service to you. We do not sell your content.</p>

      <h2>5. How we use information</h2>
      <ul>
        <li>To provide, maintain and secure the services.</li>
        <li>To authenticate users and enforce access controls.</li>
        <li>To respond to support requests.</li>
        <li>To detect, investigate and prevent misuse or security incidents.</li>
      </ul>

      <h2>6. Security</h2>
      <p>We use technical and organisational measures designed to protect information, including authentication, access controls and activity logging. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

      <h2>7. Retention</h2>
      <p>We retain information for as long as needed to provide the services and for legitimate operational, legal or security purposes. Some information may be retained after account deletion where required.</p>

      <h2>8. Your choices and rights</h2>
      <p>You may request access to, correction of, or deletion of your account and associated data. See our <a href="/account-data-deletion" className="text-[#2D8CFF] hover:underline">Account &amp; Data Deletion</a> page for how to make a request.</p>

      <h2>9. Children</h2>
      <p>Our services are intended for legal professionals and adult users and are not directed to children.</p>

      <h2>10. Changes to this policy</h2>
      <p>We may update this policy from time to time. Material changes will be reflected by updating the date above.</p>

      <h2>11. Contact</h2>
      <p>Questions about this policy can be sent to <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} className="text-[#2D8CFF] hover:underline">{PUBLIC_CONTACT_EMAIL}</a>.</p>
    </LegalShell>
  </PublicLayout>
);

export default Privacy;
